module.exports = __webpack_public_path__ + "media/images/common/gift-23cdc921d62770aea5c909282e75be32.png";